import React, {Dispatch, SetStateAction, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {DocusealBuilder} from '@docuseal/react'
import {Modal} from 'react-bootstrap'
import {resendDocumentSignatoryEmailApi} from '../core/_requests'
import {toast} from 'react-toastify'
import {useAuth} from '../../auth'
import SignInModal from '../components/SignInModal'
import {useIntl} from 'react-intl'
import Skeleton from 'react-loading-skeleton'
import {ToolTipUIForModal} from '../../widgets/components/UI/ToolTipUIForModal'
import {useThemeMode} from '../../../../_metronic/partials'
import {isMobile} from 'react-device-detect'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'

const DocumentViewModal = ({
  showDocumentViewModal,
  setShowDocumentViewModal,
  token,
  submitterDetails,
  showSignInModal,
  setShowSignInModal,
  signUrl,
  setSignUrl,
  signatoryEmail,
  setSignatoryEmail,
  getDocuments,
  viewDocumentLoading,
  signatoryId,
  signatoryLoading,
  getDashboardCounts,
  setIsViewModalTriggered,
  setSignatoryLoading,
  documentName,
}: {
  showDocumentViewModal: boolean
  setShowDocumentViewModal: Dispatch<SetStateAction<boolean>>
  token: string | undefined
  submitterDetails: any
  showSignInModal: boolean
  setShowSignInModal: Dispatch<SetStateAction<boolean>>
  signUrl: string
  setSignUrl: Dispatch<SetStateAction<string>>
  signatoryEmail: string
  setSignatoryEmail: Dispatch<SetStateAction<string>>
  viewDocumentLoading: boolean
  getDocuments: () => {}
  signatoryId: number
  signatoryLoading: boolean
  getDashboardCounts: () => void
  setIsViewModalTriggered: Dispatch<SetStateAction<boolean>>
  setSignatoryLoading: Dispatch<SetStateAction<boolean>>
  documentName: string
}) => {
  const {currentUser, companyId} = useAuth()
  const {formatMessage} = useIntl()
  const [loading, setLoading] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState<number | undefined>()
  const [isSignatoriesListOpened, setIsSignatoriesListOpened] = useState(false)
  const {mode} = useThemeMode()
  const [signatureCompleted] = useState(
    (submitterDetails &&
      submitterDetails.document_signatories.filter(
        ({isSignatureCompleted}: {isSignatureCompleted: boolean}) => isSignatureCompleted
      ).length) ||
      0
  )
  const handleResendEmail = async (signatoryId: number) => {
    setLoading(true)
    try {
      const {
        data: {success, data, errors},
      } = await resendDocumentSignatoryEmailApi(signatoryId, companyId!)
      if (success) {
        toast.success(formatMessage({id: data}))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DigitalSigningDocumentSignatureEmailResend,
            action: 'normal',
            metadata: {
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
              signatory_id: signatoryId,
              document_name: documentName || '',
            },
          },
        })
      } else {
        toast.error(formatMessage({id: errors[0]}))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DigitalSigningDocumentSignatureEmailResendFailed,
            action: 'normal',
            metadata: {
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
              signatory_id: signatoryId,
              document_name: documentName || '',
              error: errors[0],
            },
          },
        })
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Modal
        show={showDocumentViewModal}
        size='xl'
        onHide={() => {
          setShowDocumentViewModal(false)
          setIsViewModalTriggered(false)
        }}
        aria-labelledby='contained-modal-title-vcenter'
        centered
        className='document-modal-container'
      >
        <Modal.Header>
          <div className='w-100 d-flex justify-content-between align-items-center'>
            <div className='d-flex'>
              <div
                className='d-flex align-items-center cursor-pointer'
                onClick={() => {
                  setShowDocumentViewModal(false)
                  setIsViewModalTriggered(false)
                }}
              >
                <KTSVG
                  path={
                    mode === 'dark'
                      ? toAbsoluteUrl('/media/icons/digital-signing/ic_close_dark.svg')
                      : toAbsoluteUrl('/media/icons/digital-signing/ic_close.svg')
                  }
                />
              </div>
              {viewDocumentLoading ? (
                <div className='ps-4'>
                  <Skeleton
                    width={100}
                    height={25}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                </div>
              ) : (
                <div className='ps-4 font-size-20 fw-bold'>{submitterDetails.title}</div>
              )}
            </div>
            <ToolTipUIForModal
              tooltipText={formatMessage({
                id: 'This view gives you the overview of the signatories of this document. You can check who has signed & who has not & send them a reminder email from here.',
              })}
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className='d-flex justify-content-between'>
            <div className=' w-100 mb-10'>
              {viewDocumentLoading ? (
                <div className='d-flex justify-content-center mt-5'>
                  <Skeleton
                    width='70vw'
                    height={600}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                </div>
              ) : (
                <>
                  {token && (
                    <DocusealBuilder
                      host='esign.recordskeeper.ai'
                      token={token}
                      preview={true}
                      customCss={`#title_container {display:none} #main_container {background-color:${
                        mode === 'dark' ? '#1e1e2d' : '#f5f8fa'
                      }; width:97%;} #send_button {display: none;} #documents_container {height:85vh;background-color:${
                        mode === 'dark' ? '#1e1e2d' : 'white'
                      };padding:20px 20px 20px 0;margin-right:42px;scrollbar-width:thin;} #fields_list_container{display:none;} #pages_container {margin-top:20px;padding-top:0;padding-right:0px;background-color:white;scrollbar-width:thin; height:82vh;}`}
                    />
                  )}
                </>
              )}
            </div>
            {isMobile ? (
              <div className='position-relative'>
                <div
                  className={
                    isSignatoriesListOpened
                      ? 'bg-body drawer drawer-end drawer-on custom-margin-top'
                      : 'bg-body drawer drawer-end custom-margin-top'
                  }
                  id='fc-filter'
                  data-kt-drawer='true'
                  data-kt-drawer-name='filter'
                  data-kt-drawer-overlay='true'
                  data-kt-drawer-activate='true'
                  data-kt-drawer-width="{default:'300px', 'md': '400px'}"
                  data-kt-drawer-direction='end'
                >
                  <div className='submitters-container w-100'>
                    <p className='font-size-20 fw-bold'>
                      {formatMessage({id: 'Signatories'})}{' '}
                      {viewDocumentLoading ? (
                        <Skeleton
                          width={60}
                          height={20}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <>
                          ({signatureCompleted}/{submitterDetails.document_signatories.length})
                        </>
                      )}
                    </p>
                    {viewDocumentLoading ? (
                      <>
                        <div className='submitter-container'>
                          <div className='d-flex align-items-center mb-2'>
                            <Skeleton
                              width={240}
                              height={15}
                              baseColor='var(--kt-skeleton-bg-color)'
                              highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                          </div>
                          <div>
                            <Skeleton
                              width={240}
                              height={15}
                              baseColor='var(--kt-skeleton-bg-color)'
                              highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                          </div>
                          <div className='d-flex align-items-center mb-2'>
                            <Skeleton
                              width={240}
                              height={15}
                              baseColor='var(--kt-skeleton-bg-color)'
                              highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                          </div>
                          <div className={`p-3 ps-0 fw-normal mb-2`}>
                            <Skeleton
                              width={240}
                              height={15}
                              baseColor='var(--kt-skeleton-bg-color)'
                              highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                          </div>
                          <div className='w-100 d-flex flex-column'>
                            <Skeleton
                              width={240}
                              height={40}
                              baseColor='var(--kt-skeleton-bg-color)'
                              highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                            <Skeleton
                              width={240}
                              height={40}
                              baseColor='var(--kt-skeleton-bg-color)'
                              highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                          </div>
                        </div>
                        <div className='submitter-container'>
                          <div className='d-flex align-items-center mb-2'>
                            <Skeleton
                              width={240}
                              height={15}
                              baseColor='var(--kt-skeleton-bg-color)'
                              highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                          </div>
                          <div>
                            <Skeleton
                              width={240}
                              height={15}
                              baseColor='var(--kt-skeleton-bg-color)'
                              highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                          </div>
                          <div className='d-flex align-items-center mb-2'>
                            <Skeleton
                              width={240}
                              height={15}
                              baseColor='var(--kt-skeleton-bg-color)'
                              highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                          </div>
                          <div className={`p-3 ps-0 fw-normal mb-2`}>
                            <Skeleton
                              width={240}
                              height={15}
                              baseColor='var(--kt-skeleton-bg-color)'
                              highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                          </div>
                          <div className='w-100 d-flex flex-column'>
                            <Skeleton
                              width={240}
                              height={40}
                              baseColor='var(--kt-skeleton-bg-color)'
                              highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                            <Skeleton
                              width={240}
                              height={40}
                              baseColor='var(--kt-skeleton-bg-color)'
                              highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {submitterDetails.document_signatories.map(
                          (signatory: any, index: number) => (
                            <div className='submitter-container' key={signatory.signatoryId}>
                              <div className='d-flex align-items-center mb-2'>
                                <div className='dot-container' />
                                <span>{signatory.signatoryRole}</span>
                              </div>
                              <div>
                                <p className='mb-2'>{signatory.signatoryName}</p>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <KTSVG
                                  path={toAbsoluteUrl('/media/icons/digital-signing/email.svg')}
                                  svgClassName='email-icon'
                                />
                                <span>{signatory.signatoryEmail}</span>
                              </div>
                              <div
                                className={`badge ${
                                  signatory.isSignatureCompleted
                                    ? 'badge-light-success'
                                    : submitterDetails.cancelled
                                    ? 'badge-light-secondary text-clr8898'
                                    : submitterDetails.expiryDate &&
                                      new Date(submitterDetails.expiryDate).setHours(0, 0, 0, 0) <
                                        new Date().setHours(0, 0, 0, 0)
                                    ? 'badge-light-danger'
                                    : 'badge-light-danger'
                                } p-3 fw-normal mb-2`}
                              >
                                {signatory.isSignatureCompleted
                                  ? formatMessage({id: 'Completed'})
                                  : submitterDetails.cancelled
                                  ? formatMessage({id: 'Cancelled'})
                                  : submitterDetails.expiryDate &&
                                    new Date(submitterDetails.expiryDate).setHours(0, 0, 0, 0) <
                                      new Date().setHours(0, 0, 0, 0)
                                  ? formatMessage({id: 'Expired'})
                                  : formatMessage({id: 'Not Signed'})}
                              </div>
                              <div className='w-100 d-flex flex-column'>
                                {!signatory.isSignatureCompleted &&
                                  !submitterDetails.cancelled &&
                                  (!submitterDetails.expiryDate ||
                                    new Date(submitterDetails.expiryDate).setHours(0, 0, 0, 0) >=
                                      new Date().setHours(0, 0, 0, 0)) && (
                                    <>
                                      <button
                                        className='btn btn-primary mb-2'
                                        disabled={index === selectedIndex && loading}
                                        onClick={() => {
                                          setSelectedIndex(index)
                                          handleResendEmail(signatory.signatoryId)
                                        }}
                                      >
                                        {index === selectedIndex && loading ? (
                                          <span className='indicator-label font-size-13 p-0'>
                                            {formatMessage({id: 'Please wait...'})}
                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                          </span>
                                        ) : (
                                          <>{formatMessage({id: 'Resend Email'})}</>
                                        )}
                                      </button>
                                      {signatory.signatoryEmail === currentUser?.email && (
                                        <button
                                          className='btn btn-primary mb-2'
                                          disabled={signatoryLoading}
                                          onClick={() => {
                                            setSignatoryEmail(signatory.signatoryEmail)
                                            setSignUrl(signatory.docusealSlug)
                                            setShowSignInModal(true)
                                          }}
                                        >
                                          {signatoryLoading ? (
                                            <span className='indicator-label font-size-13 p-0'>
                                              {formatMessage({id: 'Please wait...'})}
                                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                          ) : (
                                            <> {formatMessage({id: 'Sign Now'})}</>
                                          )}
                                        </button>
                                      )}

                                      {/* <button className='btn btn-secondary text-muted'>
                                <a
                                  target='_blank'
                                  rel='noreferrer'
                                  href={submitterDetails.signing_template?.docusealPdfUrl}
                                  className='text-decoration-none text-clr7e8'
                                >
                                  {formatMessage({id: 'Sign In Person'})}
                                </a>
                              </button> */}
                                    </>
                                  )}
                              </div>
                            </div>
                          )
                        )}
                      </>
                    )}
                  </div>
                </div>
                <div
                  className='hamburger-container'
                  style={{right: isSignatoriesListOpened ? '233px' : '0'}}
                  onClick={() => setIsSignatoriesListOpened((prev) => !prev)}
                >
                  {isSignatoriesListOpened ? (
                    <KTSVG
                      path={toAbsoluteUrl('/media/icons/digital-signing/ic_hamburger_close.svg')}
                      svgClassName='hamburger-icon-size'
                    />
                  ) : (
                    <KTSVG
                      path={toAbsoluteUrl('/media/icons/digital-signing/ic_hamburger_open.svg')}
                      svgClassName='hamburger-icon-size'
                    />
                  )}
                  <KTSVG
                    path={toAbsoluteUrl('/media/icons/digital-signing/ic_hamburger.svg')}
                    svgClassName='hamburger-icon-size'
                  />
                </div>
              </div>
            ) : (
              <div className='submitters-container'>
                <p className='font-size-20 fw-bold'>
                  {formatMessage({id: 'Signatories'})}{' '}
                  {viewDocumentLoading ? (
                    <Skeleton
                      width={60}
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  ) : (
                    <>
                      ({signatureCompleted}/{submitterDetails.document_signatories.length})
                    </>
                  )}
                </p>
                {viewDocumentLoading ? (
                  <>
                    <div className='submitter-container'>
                      <div className='d-flex align-items-center mb-2'>
                        <Skeleton
                          width={240}
                          height={15}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div>
                        <Skeleton
                          width={240}
                          height={15}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='d-flex align-items-center mb-2'>
                        <Skeleton
                          width={240}
                          height={15}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className={`p-3 ps-0 fw-normal mb-2`}>
                        <Skeleton
                          width={240}
                          height={15}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='w-100 d-flex flex-column'>
                        <Skeleton
                          width={240}
                          height={40}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                        <Skeleton
                          width={240}
                          height={40}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                    <div className='submitter-container'>
                      <div className='d-flex align-items-center mb-2'>
                        <Skeleton
                          width={240}
                          height={15}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div>
                        <Skeleton
                          width={240}
                          height={15}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='d-flex align-items-center mb-2'>
                        <Skeleton
                          width={240}
                          height={15}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className={`p-3 ps-0 fw-normal mb-2`}>
                        <Skeleton
                          width={240}
                          height={15}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='w-100 d-flex flex-column'>
                        <Skeleton
                          width={240}
                          height={40}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                        <Skeleton
                          width={240}
                          height={40}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {submitterDetails.document_signatories.map((signatory: any, index: number) => (
                      <div className='submitter-container' key={signatory.signatoryId}>
                        <div className='d-flex align-items-center mb-2'>
                          <div className='dot-container' />
                          <span>{signatory.signatoryRole}</span>
                        </div>
                        <div>
                          <p className='mb-2'>{signatory.signatoryName}</p>
                        </div>
                        <div className='d-flex align-items-center mb-2'>
                          <KTSVG
                            path={toAbsoluteUrl('/media/icons/digital-signing/email.svg')}
                            svgClassName='email-icon'
                          />
                          <span>{signatory.signatoryEmail}</span>
                        </div>
                        <div
                          className={`badge ${
                            signatory.isSignatureCompleted
                              ? 'badge-light-success'
                              : submitterDetails.cancelled
                              ? 'badge-light-secondary text-clr8898'
                              : submitterDetails.expiryDate &&
                                new Date(submitterDetails.expiryDate).setHours(0, 0, 0, 0) <
                                  new Date().setHours(0, 0, 0, 0)
                              ? 'badge-light-danger'
                              : 'badge-light-danger'
                          } p-3 fw-normal mb-2`}
                        >
                          {signatory.isSignatureCompleted
                            ? formatMessage({id: 'Completed'})
                            : submitterDetails.cancelled
                            ? formatMessage({id: 'Cancelled'})
                            : submitterDetails.expiryDate &&
                              new Date(submitterDetails.expiryDate).setHours(0, 0, 0, 0) <
                                new Date().setHours(0, 0, 0, 0)
                            ? formatMessage({id: 'Expired'})
                            : formatMessage({id: 'Not Signed'})}
                        </div>
                        <div className='w-100 d-flex flex-column'>
                          {!signatory.isSignatureCompleted &&
                            !submitterDetails.cancelled &&
                            (!submitterDetails.expiryDate ||
                              new Date(submitterDetails.expiryDate).setHours(0, 0, 0, 0) >=
                                new Date().setHours(0, 0, 0, 0)) && (
                              <>
                                <button
                                  className='btn btn-primary mb-2'
                                  disabled={index === selectedIndex && loading}
                                  onClick={() => {
                                    setSelectedIndex(index)
                                    handleResendEmail(signatory.signatoryId)
                                  }}
                                >
                                  {index === selectedIndex && loading ? (
                                    <span className='indicator-label font-size-13 p-0'>
                                      {formatMessage({id: 'Please wait...'})}
                                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                    </span>
                                  ) : (
                                    <>{formatMessage({id: 'Resend Email'})}</>
                                  )}
                                </button>
                                {signatory.signatoryEmail === currentUser?.email && (
                                  <button
                                    className='btn btn-primary mb-2'
                                    disabled={signatoryLoading}
                                    onClick={() => {
                                      setSignatoryEmail(signatory.signatoryEmail)
                                      setSignUrl(signatory.docusealSlug)
                                      setShowSignInModal(true)
                                    }}
                                  >
                                    {signatoryLoading ? (
                                      <span className='indicator-label font-size-13 p-0'>
                                        {formatMessage({id: 'Please wait...'})}
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                      </span>
                                    ) : (
                                      <> {formatMessage({id: 'Sign Now'})}</>
                                    )}
                                  </button>
                                )}

                                {/* <button className='btn btn-secondary text-muted'>
                                <a
                                  target='_blank'
                                  rel='noreferrer'
                                  href={submitterDetails.signing_template?.docusealPdfUrl}
                                  className='text-decoration-none text-clr7e8'
                                >
                                  {formatMessage({id: 'Sign In Person'})}
                                </a>
                              </button> */}
                              </>
                            )}
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
      {signatoryId && (
        <SignInModal
          showSignInModal={showSignInModal}
          setShowSignInModal={setShowSignInModal}
          signUrl={signUrl}
          signatoryEmail={signatoryEmail}
          getDocuments={getDocuments}
          signatoryId={signatoryId}
          getDashboardCounts={getDashboardCounts}
          setSignatoryLoading={setSignatoryLoading}
          documentName={documentName}
        />
      )}
    </>
  )
}

export default DocumentViewModal
